<template>
  <el-dialog
      :close-on-click-modal="false"
      title="收款信息"
      :lock-scroll="true"
      :visible.sync="dialogFormVisible"
  >
    <section v-loading="getDetailLoading">
      <qx-custom-form
          @sub="sub"
          :noSubBtn="true"
          ref="customForm"
          :formData="formData"
      />
    </section>
    <section slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button type="primary" @click="customFormPost" :loading="subLoading || getDetailLoading">确 定</el-button>
    </section>
  </el-dialog>
</template>

<script>
import {
  getOrderCollection,
  setOrderCollection,
} from 'api/operate';
export default {
  data () {
    return {
      getDetailLoading: false, // 获取详情loading
      dialogFormVisible: false,
      subLoading: false, // 提交loading
      type: '', // add/新增 edit/修改
      merLoading: false, // 商户选项loading中
      originData: {},
      formData: {
        form: [
          {
            label: '收款人',
            value: 'collectionMan',
            type: 'input',
            placeholder: '请输入收款人',
          },
          {
            label: '收款时间',
            value: 'collectionTime',
            type: 'date',
            width: '240px',
            attr: {
              type: 'datetime',
              time: '00:00:00',
            },
          },
          {
            label: '收款模式',
            value: 'collectionMode',
            type: 'input',
            placeholder: '请输入收款模式',
          },
          {
            label: '收款备注',
            value: 'collectionRemark',
            type: 'input',
            placeholder: '请输入收款备注',
          },
        ],
      },
    };
  },
  methods: {

    /**
     * @param {Object} item 修改的项
     * @returns {void}
     * @description 打开弹窗并初始化数据
     */
    async show (item) {
      this.dialogFormVisible = true; // 打开弹窗
      this.originData = item;
      this.getDetailLoading = true;
      const collectionRes = await getOrderCollection({
        orderId: item.orderId,
      });
      this.getDetailLoading = false;
      // if (collectionRes.collectionMan !== '' && collectionRes.collectionMan !== undefined) {
      //   item.collectionMan = collectionRes.collectionMan;
      // }
      // if (collectionRes.collectionTime !== '' && collectionRes.collectionTime !== undefined) {
      //   item.collectionTime = collectionRes.collectionTime;
      // }
      // if (collectionRes.collectionMode !== '' && collectionRes.collectionMode !== undefined) {
      //   item.collectionMode = collectionRes.collectionMode;
      // }
      // if (collectionRes.collectionRemark !== '' && collectionRes.collectionRemark !== undefined) {
      //   item.collectionRemark = collectionRes.collectionRemark;
      // }
      this.$refs.customForm.setVal('collectionMan', collectionRes.collectionMan);
      this.$refs.customForm.setVal('collectionTime', collectionRes.collectionTime);
      this.$refs.customForm.setVal('collectionMode', collectionRes.collectionMode);
      this.$refs.customForm.setVal('collectionRemark', collectionRes.collectionRemark);
      this.$refs.customForm.setVal(item);
    },

    customFormPost () {
      this.$refs.customForm.sub();
    },

    /**
     * @param {Object} form 表单数据
     * @returns {void}
     * @description 弹窗确定按钮事件
     */
    async sub (form) {
      this.subLoading = true;
      const res = await setOrderCollection({
        orderId: this.originData.orderId,
        collectionMan: form.collectionMan,
        collectionTime: `${this.formatDate(form.collectionTime, 1)}`,
        collectionMode: form.collectionMode,
        collectionRemark: form.collectionRemark,
      });
      this.subLoading = false;
      if (!res.failed) {
        this.dialogFormVisible = false; // 关闭弹窗
        this.$message({
          type: 'success',
          message: '保存成功',
        });
        this.$emit('sub');
      }
    },
  },
};
</script>

<style>
</style>
